import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class GpsDevicesAvailableStore extends LocalModel {
    constructor() {
        super('gpsDevicesAvailable', {
            namePlural: 'gpsDevicesAvailables',
            namePluralReal: 'gpsDevicesAvailables',
            sort: 'gpsId',
            limit: 500,
            api: {
                search: {
                    url: '/api/gpsdevicesavailables/',
                    params: {
                        limit: 100,
                        sort: 'gpsId',
                    },
                },
                load: {
                    url: '/api/gpsdevicesavailables/',
                    params: {},
                },
                save: {
                    url: '/api/gpsdevicesavailables/',
                    params: {},
                },
                delete: {
                    url: '/api/gpsdevicesavailables/',
                    params: {},
                },
            },
        });
    }

    @observable newGpsDevicesAvailable = {};

    @observable gpsDevicesAvailable = {};

    @observable gpsDevicesAvailables = [];

}

const store = new GpsDevicesAvailableStore();
export default store;
